// @generated by protoc-gen-es v2.12.0 with parameter "target=ts"
// @generated from file search/v1/search.proto (package search.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file search/v1/search.proto.
 */
export const file_search_v1_search: GenFile = /*@__PURE__*/
  fileDesc("ChZzZWFyY2gvdjEvc2VhcmNoLnByb3RvEglzZWFyY2gudjEiLAoOUHJvcGVydHlGaWx0ZXISCwoDa2V5GAEgASgJEg0KBXZhbHVlGAIgASgJIncKDVNlYXJjaFJlcXVlc3QSDAoEdGV4dBgBIAEoCRINCgV0eXBlcxgCIAMoCRIqCgdmaWx0ZXJzGAMgAygLMhkuc2VhcmNoLnYxLlByb3BlcnR5RmlsdGVyEg0KBWxpbWl0GAQgASgFEg4KBm9mZnNldBgFIAEoBSJDCglTZWFyY2hIaXQSCgoCaWQYASABKAkSDAoEdHlwZRgCIAEoCRINCgV0aXRsZRgDIAEoCRINCgVzY29yZRgEIAEoASI0Cg5TZWFyY2hSZXNwb25zZRIiCgRoaXRzGAEgAygLMhQuc2VhcmNoLnYxLlNlYXJjaEhpdDJOCg1TZWFyY2hTZXJ2aWNlEj0KBlNlYXJjaBIYLnNlYXJjaC52MS5TZWFyY2hSZXF1ZXN0Ghkuc2VhcmNoLnYxLlNlYXJjaFJlc3BvbnNlQk1aS2dpdGh1Yi5jb20vY29yb25pc2hlYWx0aC9jb3JvbmlzLWh1Yi9zZXJ2aWNlcy9zZWFyY2gvZ2VuL3NlYXJjaC92MTtzZWFyY2h2MWIGcHJvdG8z");

/**
 * PropertyFilter constrains a structured property to an exact value.
 *
 * @generated from message search.v1.PropertyFilter
 */
export type PropertyFilter = Message<"search.v1.PropertyFilter"> & {
  /**
   * @generated from field: string key = 1;
   */
  key: string;

  /**
   * @generated from field: string value = 2;
   */
  value: string;
};

/**
 * Describes the message search.v1.PropertyFilter.
 * Use `create(PropertyFilterSchema)` to create a new message.
 */
export const PropertyFilterSchema: GenMessage<PropertyFilter> = /*@__PURE__*/
  messageDesc(file_search_v1_search, 0);

/**
 * @generated from message search.v1.SearchRequest
 */
export type SearchRequest = Message<"search.v1.SearchRequest"> & {
  /**
   * Free-text query; all terms must match (AND). May be empty when filters
   * are set.
   *
   * @generated from field: string text = 1;
   */
  text: string;

  /**
   * Restrict to these entity types (empty = any).
   *
   * @generated from field: repeated string types = 2;
   */
  types: string[];

  /**
   * Structured property filters (AND-matched).
   *
   * @generated from field: repeated search.v1.PropertyFilter filters = 3;
   */
  filters: PropertyFilter[];

  /**
   * Max hits to return; <=0 uses the server default cap.
   *
   * @generated from field: int32 limit = 4;
   */
  limit: number;

  /**
   * Pagination offset.
   *
   * @generated from field: int32 offset = 5;
   */
  offset: number;
};

/**
 * Describes the message search.v1.SearchRequest.
 * Use `create(SearchRequestSchema)` to create a new message.
 */
export const SearchRequestSchema: GenMessage<SearchRequest> = /*@__PURE__*/
  messageDesc(file_search_v1_search, 1);

/**
 * SearchHit is one result: identity + relevance only.
 *
 * @generated from message search.v1.SearchHit
 */
export type SearchHit = Message<"search.v1.SearchHit"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string type = 2;
   */
  type: string;

  /**
   * @generated from field: string title = 3;
   */
  title: string;

  /**
   * @generated from field: double score = 4;
   */
  score: number;
};

/**
 * Describes the message search.v1.SearchHit.
 * Use `create(SearchHitSchema)` to create a new message.
 */
export const SearchHitSchema: GenMessage<SearchHit> = /*@__PURE__*/
  messageDesc(file_search_v1_search, 2);

/**
 * @generated from message search.v1.SearchResponse
 */
export type SearchResponse = Message<"search.v1.SearchResponse"> & {
  /**
   * @generated from field: repeated search.v1.SearchHit hits = 1;
   */
  hits: SearchHit[];
};

/**
 * Describes the message search.v1.SearchResponse.
 * Use `create(SearchResponseSchema)` to create a new message.
 */
export const SearchResponseSchema: GenMessage<SearchResponse> = /*@__PURE__*/
  messageDesc(file_search_v1_search, 3);

/**
 * SearchService exposes the platform search-index projection (HUB-281): a
 * queryable index over entities, searchable by type, property, and content.
 *
 * PHI: hit titles come from indexed content, which is PHI-by-default. Results
 * MUST be access-filtered to the requester's permissions before they leave the
 * server (the Index port's access-predicate wiring is a follow-on; until then
 * the endpoint sits behind the console auth interceptors like every other
 * service surface). Never log query text or hit titles.
 *
 * @generated from service search.v1.SearchService
 */
export const SearchService: GenService<{
  /**
   * Search runs a full-text + structured query against the index and returns
   * hits ordered by relevance (identity + relevance only — no content bodies).
   *
   * @generated from rpc search.v1.SearchService.Search
   */
  search: {
    methodKind: "unary";
    input: typeof SearchRequestSchema;
    output: typeof SearchResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_search_v1_search, 0);

